import sliceCreator from '../../index.jsx';
import {GET_VILLAGE_BY_ID} from '../../../constants/index.jsx';
const _getVillageByIdAction = sliceCreator('GET_VILLAGE_BY_ID', GET_VILLAGE_BY_ID, 'get');

const { asyncAction: getVillageByIdAction, reducer, clearData: clearGetVillageByIdAction } = _getVillageByIdAction;

export default reducer;

export {
    getVillageByIdAction,
    clearGetVillageByIdAction
}